module.exports = __webpack_public_path__ + "static/media/main_background.8d3340a5.jpg";